/* eslint-disable react-hooks/exhaustive-deps */
import {
  createContext,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { To, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { iTech } from "../../components/ListTechs";
import { iProvidersProps } from "../../components/Providers";
import { iLogin } from "../../pages/Home";
import { iRegister } from "../../pages/Register";
import { instace } from "../../services/api";

interface iUseNavigate {
  (to: To): void;
  options?: {
    replace?: boolean;
  };
}

interface iUser {
  id: string;
  name: string;
  email: string;
  course_module: string;
  bio: string;
  contact: string;
  techs: iTech[];
}

interface iUseUserProvider {
  techList: iTech[];
  setTechList: React.Dispatch<SetStateAction<iTech[]>>;
  navigate: iUseNavigate;
  userLogin(
    data: iLogin,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void>;
  userRegister(
    data: iRegister,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void>;
  user: iUser | null;
  loading: boolean;
}

interface iUserResponse {
  user: iUser;
  token: string;
}

export const UserContext = createContext<iUseUserProvider>(
  {} as iUseUserProvider
);

const UserProvider = ({ children }: iProvidersProps) => {
  const [user, setUser] = useState<iUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [techList, setTechList] = useState<iTech[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function autoLogin() {
      const token = localStorage.getItem("@kenzieHubToken");
      if (token) {
        try {
          instace.defaults.headers.common.authorization = `Bearer ${token}`;

          const response = await instace.get<iUser>("/profile");

          setUser(response.data);
          setTechList(response.data.techs);
        } catch (error) {
          window.localStorage.clear();
          console.error(error);
        }
      }
      setLoading(false);
    }

    autoLogin();
  }, []);

  const userLogin = async (
    data: iLogin,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void> => {
    try {
      setLoadButton(true);

      const response = await instace.post<iUserResponse>("sessions", data);
      window.localStorage.clear();
      window.localStorage.setItem("@kenzieHubToken", response.data.token);

      setUser(response.data.user);
      setTechList(response.data.user.techs);
      navigate(`/dashboard`);
    } catch (error) {
      toast.error("Email e/ou Senha incorreto!", {
        autoClose: 3000,
        theme: "dark",
      });
    } finally {
      setLoadButton(false);
    }
  };

  useEffect(() => {
    const redirict = () => {
      const token = localStorage.getItem("@kenzieHubToken");
      if (token) {
        navigate("/dashboard");
      }
    };

    redirict();
  }, [navigate]);

  const userRegister = async (
    data: iRegister,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void> => {
    try {
      setLoadButton(true);
      await instace.post("users", data);
      toast.success("Usuario criado com sucesso!", {
        autoClose: 3000,
        theme: "dark",
      });
      navigate("/");
    } catch (error) {
      toast.error("E-mail ja cadastrado!", {
        autoClose: 3000,
        theme: "dark",
      });
    } finally {
      setLoadButton(false);
    }
  };

  return (
    <UserContext.Provider
      value={{
        navigate,
        userLogin,
        userRegister,
        user,
        loading,
        techList,
        setTechList,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserContext);

  return context;
};

export default UserProvider;
